import * as DatabaseService from '@/services/Database.service';
import * as AuthMutations from '@/store/mutations/Auth.mutations';
import * as StandupMutations from '@/store/mutations/Standup.mutations';
import * as StandupActions from '@/store/actions/Standup.actions';
import { dictionaryFromDocumentArray } from '@/helpers/dataHelpers';

const getInitialState = () => ({
  standups: {},
  isStandupLoading: false,
  isWritingData: false,
});

const state = getInitialState();

const getters = {
  standupIds(state) {
    return Object.keys(state.standups);
  },
};

const mutations = {
  [StandupMutations.STANDUP_REQUEST_DATA](state) {
    state.isStandupLoading = true;
  },
  [StandupMutations.STANDUP_BEGIN_WRITE_DATA](state) {
    state.isWritingData = true;
  },
  [StandupMutations.RECEIVE_STANDUPS](state, payload) {
    state.standups = {
      ...state.standups,
      ...payload.standups,
    };
    state.isStandupLoading = false;
  },
  [StandupMutations.STANDUP_COMPLETE_WRITE_DATA](state) {
    state.isWritingData = false;
  },
  [AuthMutations.LOG_OUT](state) {
    Object.assign(state, getInitialState());
  },
};

const actions = {
  /* PLACEHOLDER
  async [StandupActions.FETCH_STANDUP_BY_ID](context, payload) {
  }, */
  async [StandupActions.FETCH_STANDUPS_BY_IDS](context, payload) {
    context.commit(StandupMutations.STANDUP_REQUEST_DATA);
    return new Promise(async (resolve, reject) => {
      try {
        const standupDocuments = await Promise.all(DatabaseService.getStandupsByIds(payload.standupIds));
        const shapedStandupDocuments = dictionaryFromDocumentArray(standupDocuments);
        context.commit(StandupMutations.RECEIVE_STANDUPS, { standups: shapedStandupDocuments });
        resolve();
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        reject();
      }
    });
  },
  async [StandupActions.FETCH_CURRENT_DAY_STANDUP_BY_TEAM](context, payload) {
    context.commit(StandupMutations.STANDUP_REQUEST_DATA);
    return new Promise(async (resolve, reject) => {
      try {
        const { docs: standupDocuments } = await DatabaseService.getCurrentDayStandupByTeam(payload.teamId);
        const shapedStandupDocuments = dictionaryFromDocumentArray(standupDocuments);
        context.commit(StandupMutations.RECEIVE_STANDUPS, { standups: shapedStandupDocuments });
        resolve();
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        reject();
      }
    });
  },
  async [StandupActions.CREATE_STANDUP](context, payload) {
    context.commit(StandupMutations.STANDUP_BEGIN_WRITE_DATA);
    return new Promise(async (resolve, reject) => {
      try {
        const newStandupRef = await DatabaseService.addNewStandup(payload.newStandup);
        context.commit(StandupMutations.STANDUP_COMPLETE_WRITE_DATA);
        await context.dispatch(StandupActions.FETCH_STANDUPS_BY_IDS, { standupIds: [newStandupRef.id] });
        resolve(newStandupRef);
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        reject(err);
      }
    });
  },
  async [StandupActions.UPDATE_STANDUP](context, payload) {
    context.commit(StandupMutations.STANDUP_BEGIN_WRITE_DATA);
    return new Promise(async (resolve, reject) => {
      try {
        await DatabaseService.updateStandupById(payload.standupId, payload.updatedStandup);
        context.commit(StandupMutations.STANDUP_COMPLETE_WRITE_DATA);
        await context.dispatch(StandupActions.FETCH_STANDUPS_BY_IDS, { standupIds: [payload.standupId] });
        resolve();
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        reject(err);
      }
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
